import type { FileResponse, FileUrlResponse } from 'types';

export const mergeFilesWithUrls = (
  fileIds: string[],
  files: FileResponse[],
  fileUrls: FileUrlResponse[],
  fallbackFiles: FileResponse[] = []
): FileResponse[] => {
  if (!fileIds.length) return [];

  return fileIds
    .map((id) => {
      const fromApi = files.find((file) => file.id === id);
      const fallback = fallbackFiles.find((file) => file.id === id);
      const base = fromApi ?? fallback;

      if (!base) return null;

      const url = fileUrls.find((item) => item.id === id)?.url ?? base.url ?? '';
      return { ...base, url };
    })
    .filter((file): file is FileResponse => Boolean(file));
};
